import React, { useContext, useState, useEffect } from 'react';
import { CartContext } from '../../context/cart-context';
import { Context as ProductsContext  } from '../../context/products-context';
import Layout from '../shared/layout';
import ShippingAddress from './custom-checkout/shipping-address';
import CustomCheckout from './custom-checkout/custom-checkout';
import './checkout.styles.scss';
//import StripeCheckout from './stripe-checkout/stripe-checkout';

const Checkout = () => {
  const { itemCount, total, cartItems } = useContext(CartContext);
  const { getSelectedPostageType, state:{selectedPostageType} } = useContext(ProductsContext);
  const [shipping, setShipping] = useState(null);
  const postageType = selectedPostageType;

  const addressShown = {
    display: (shipping ? 'none' : 'block')
  }
  const cardShown = {
    display: (shipping ? 'block' : 'none')
  }

  // useEffect( () => {
  //   getSelectedPostageType();
  //   //setPostageType(selectedPostageType);
  // },[postageType]);



  return (
    <Layout>
      <div className='checkout'>
        <h2>Checkout Summary</h2>
        <h3>{`Total Items: ${itemCount}`}</h3>
        {
          selectedPostageType
          ? <h4>{`Amount to Pay: £${(parseFloat(selectedPostageType.price) + total).toFixed(2)}`}</h4>
          : null
        }
        
        <div style={addressShown}>
          <ShippingAddress setShipping={setShipping} />
        </div>
        <div style={cardShown}>
          <CustomCheckout { ...{ shipping, cartItems, selectedPostageType } }/>
        </div>
      </div>
    </Layout>
  );
}

export default Checkout;